import {
  ImageHomeLandingPageThumbnail,
  ImageHubThumbnailTemplate03,
  ImageSalesLandingPageThumbnail,
} from '@/assets/images';
import { HubTemplateEnum } from '@/graphql/types';
import { useEffect } from 'react';
import { useEditHubStore } from '../editHubStore';

export const HubTemplateInfoOptions = {
  [HubTemplateEnum.HomeLandingPage]: {
    type: HubTemplateEnum.HomeLandingPage,
    title: 'Integrated Hub',
    description: 'A hub that is integrated within the home landing page. This will never open in a new tab.',
    image: ImageHomeLandingPageThumbnail,
  },
  [HubTemplateEnum.SalesLandingPage]: {
    type: HubTemplateEnum.SalesLandingPage,
    title: 'Standalone Hub',
    description: 'A hub that is standalone and performs like a micro-site.',
    image: ImageSalesLandingPageThumbnail,
  },
  [HubTemplateEnum.HubTemplate_03]: {
    type: HubTemplateEnum.HubTemplate_03,
    title: 'Panels Hub',
    description: 'A hub that is split into two halfs. Bigger panels for more content.',
    image: ImageHubThumbnailTemplate03,
  },
};

export const getHubTemplateInfo = (key: HubTemplateEnum | string | null | undefined) => {
  switch (key) {
    case HubTemplateEnum.HomeLandingPage:
      return HubTemplateInfoOptions[HubTemplateEnum.HomeLandingPage];
    case HubTemplateEnum.SalesLandingPage:
      return HubTemplateInfoOptions[HubTemplateEnum.SalesLandingPage];
    case HubTemplateEnum.HubTemplate_03:
      return HubTemplateInfoOptions[HubTemplateEnum.HubTemplate_03];
    default:
      return {
        type: null,
        title: 'Unknown',
        description: 'Unknown template.',
        image: 'https://via.placeholder.com/345x140',
      };
  }
};

export const getHubTemplateEnumText = getHubTemplateInfo;

const DefaultSelectTemplate = () => {
  const template = useEditHubStore((store) => store.template);

  useEffect(() => {
    if (!template) {
      useEditHubStore.setState({
        template: HubTemplateEnum.SalesLandingPage,
      });

      if (useEditHubStore.temporal?.getState) {
        useEditHubStore.temporal.getState().clear();
      }
    }
  }, [template]);

  return null;
};

export default DefaultSelectTemplate;
